module.exports = __webpack_public_path__ + "img/Feature-5.21cf4a6.svg";